/** Textos de Minhas vendas — puros, testados em `tests/minhas-vendas`. */

/** A pergunta antes de cancelar: cancelar tira a premiação da venda. */
export function perguntaDoCancelamento(v: {
  readonly descricao: string;
  readonly quantidade: number;
}): string {
  return `Cancelar a venda de ${v.descricao} (${String(v.quantidade)} un.)?`;
}

/**
 * Carrega a lista do período valendo SÓ a resposta do ÚLTIMO pedido (caça a bugs 26/09, item 34).
 * Antes, trocando rápido de período ("Hoje" → "Semana"), a resposta que chegasse por último
 * ganhava — e a tela mostrava a lista de um período com outro selecionado. Agora a resposta de um
 * pedido que já foi substituído é descartada (não aplica nem erro nem lista).
 */
export function carregadorDoUltimo<P, R>(
  ler: (p: P) => Promise<R>,
  aplicar: (r: R) => void,
): (p: P) => Promise<void> {
  let vez = 0;
  return async (p) => {
    vez += 1;
    const minha = vez;
    const r = await ler(p);
    if (minha === vez) aplicar(r);
  };
}
